<template>
  <div class="buttons-panel" v-loading="loading">
    <div
      v-for="(row, i) in buttons_menu"
      :key="i"
      :class="['buttons-panel__buttons', { gap16: topPanel }]"
    >
      <template v-for="btn in row">
        <Tooltip
          v-if="
            btn.id === BTN.ID.SHARE_BY_CANDIDATE || btn.id === BTN.ID.DUPLICATES
          "
          :key="btn.id"
          :content="btn.help || '[нет текста]'"
        >
          <Button
            :buttonText="getButtonText(btn)"
            :buttonColor="btn.colorVisualClass"
            :disabled="disabledBtns[btn.id] || btn.disabled"
            buttonSize="big"
            hasLeftIcon
            :iconSrc="btn.icon"
            @click="
              btn.callback
                ? btn.callback
                : btn.intents
                ? btnAction(btn)
                : () => {}
            "
          ></Button>
        </Tooltip>
        <ActionsMenu
          v-else-if="btn.type && btn.type == 'parent'"
          :key="btn.id"
          :actions="btn.child"
          :disabledBtns="disabledBtns"
          class="actions-menu"
          @handleCommand="btnAction"
          :buttonText="
            btn.lbl && btn.lbl.value && typeof btn.lbl.value != 'object'
              ? btn.lbl.value
              : ''
          "
          :iconUrl="btn.icon"
          :buttonSize="btn.sizeVisualClass || 'medium'"
          :menuColor="btn.colorVisualClass ? btn.colorVisualClass : 'blue'"
        />
        <div
          v-else-if="btn.type && btn.type == 'bool'"
          :key="btn.id"
          class="buttons-panel__switcher"
        >
          <Switcher
            :name="btn.name"
            size="small"
            :model="
              btn.name === 'HRPAC_CANDIDATE_RESPONDS_SHOW_NEW'
                ? showOnlyNewRespondsAdvanced
                : approvalRequiredAdvanced
            "
            @switch="
              btn.callback
                ? btn.callback
                : btn.intents
                ? btnAction(btn)
                : noAction(btn)
            "
          />
          <p class="buttons-panel__text" v-if="btn.lbl">{{ btn.lbl.value }}</p>
        </div>
        <Button
          v-else
          v-loading="btnWithLoader(btn.id)"
          :key="btn.id"
          :ref="btn.type === 'customRightPanelButton' ? 'rightPanel' : ''"
          :buttonText="getButtonText(btn)"
          :buttonColor="
            btn.type == 'customRightPanelButton'
              ? 'white'
              : btn.colorVisualClass
              ? btn.colorVisualClass
              : 'blue'
          "
          :disabled="
            disabledBtns[btn.id] ||
            disabledBtns[btn.name] ||
            btn.disabled ||
            noVacancyInMassAttachMent(btn) ||
            (btn.visibility && btn.visibility == 'disabled') ||
            (clickSaveform &&
              btn.id == 'save' &&
              (module == 'HRPAC_EVENT' || module == 'HRPAC_CALENDAR'))
          "
          :buttonSize="btn.sizeVisualClass || 'medium'"
          hasLeftIcon
          :iconSrc="btn.icon"
          @click="
            btn.callback
              ? btn.callback
              : btn.intents
              ? btnAction(btn)
              : noAction(btn)
          "
        >
        </Button>
      </template>
    </div>
  </div>
</template>

<script>
import { eventBus } from '@/bus';
import { getController } from '@/controllers/request.js';
import { store } from '@/store';
import {
  ACTION,
  BUTTON,
  EVENTBUS_EVENTS,
  INTENT_AREA,
  INTENT_TYPE,
  MODULE
} from '@/utils/constants';
import {
  errorMsg,
  form,
  metadata,
  mixin,
  parseIntent,
  saveForm
} from '@/utils/mixins';
import Button from 'Elements/Button/Button';
import ActionsMenu from 'Elements/Menu/ActionsMenu';
import Switcher from 'Elements/Switch/Switch';
import Tooltip from 'Elements/Tooltip/Tooltip';

export default {
  mixins: [form, mixin, saveForm, metadata, parseIntent, errorMsg],
  props: {
    breakOnSave: {
      type: Boolean,
      default: false
    },
    module: {
      type: String,
      default: ''
    },
    buttons_menu: {
      type: Array,
      default() {
        return [];
      }
    },
    disabledBtns: {
      type: Object,
      default() {
        return {};
      }
    },
    needCoordination: Boolean,
    topPanel: Boolean,
    loading: Boolean
  },
  data() {
    return {
      BTN: BUTTON,
      form: {}
    };
  },
  created() {
    eventBus.$on('openRightPanel', () => {
      if (this.$refs?.rightPanel) {
        this.$refs?.rightPanel[0]?.click();
      }
    });
  },
  computed: {
    showOnlyNewRespondsAdvanced() {
      return (
        store.state.filters.filterConfig?.filters?.show_only_new_advanced
          ?.value || false
      );
    },
    approvalRequiredAdvanced() {
      return (
        store.state.filters.filterConfig?.filters?.approval_required_advanced
          ?.value || false
      );
    },
    clickSaveform() {
      return store.state.common.clickSaveform;
    },
    currentVacancyCandidateID() {
      return store.state.vacancy?.currentVacancyCandidate?.ID || null;
    },
    getLengthChangeableList() {
      return store.state.vacancy.changeableList?.list || [];
    }
  },
  methods: {
    noVacancyInMassAttachMent(btn) {
      return btn.id == 'Attach'
        ? store.state.attachment.selectedItems.length
          ? false
          : true
        : false;
    },
    noAction(btn) {
      this.$emit('handleClick', btn.id);
    },
    getButtonText(btn) {
      const count =
        btn?.intents?.length &&
        btn?.intents[0] &&
        btn?.intents[0].request?.dynamic_request_params?.vacancy_ids
          ? btn?.intents[0].request?.dynamic_request_params?.vacancy_ids?.length
          : btn?.intents?.length &&
            btn?.intents[0] &&
            btn?.intents[0].request?.dynamic_request_params?.subpanel_id?.length
          ? btn?.intents[0].request?.dynamic_request_params?.subpanel_id?.length
          : '';
      const text =
        this.needCoordination && btn.id == 'save'
          ? 'Далее к согласованию'
          : btn.lbl && btn.lbl.value
          ? btn.lbl.value
          : typeof btn.lbl == 'string' && btn.lbl.length > 0
          ? btn.lbl
          : '';
      return count ? `${text} (${count})` : text;
    },
    btnWithLoader(id) {
      return id === BUTTON.ID.PICK_CANDIDATE && this.loading;
    },
    filteredButtons(btns) {
      return btns.filter(btn => !btn.custom_display);
    },
    async btnAction(button) {
      const intents = button.intents;

      if (button.id === 'clean_form') {
        eventBus.$emit(EVENTBUS_EVENTS.CLEAN_FORM);
        return;
      }

      for (let index in intents) {
        if (window.umami.track) {
          window.umami.track(
            `${intents[index].module}_${intents[index].action}`
          );
        }

        if (intents[index].module == 'HRPAC_TAGS') {
          store.commit('candidate/setVisibleElem', {
            elem: 'tagForm',
            visible: true
          });
        } else if (intents[index].intentArea == INTENT_AREA.RELOAD_TAB) {
          if (intents[index]?.request?.request_params?.tab_id == 'candidates') {
            store.commit('vacancy/setParam', {
              name: 'currentVacancyCandidate',
              val: null
            });
            store.commit('rightPanel/setParam', {
              name: 'panelMode',
              val: null
            });
          }
          eventBus.$emit(
            EVENTBUS_EVENTS.RELOAD_TAB,
            intents[index]?.request?.request_params?.tab_id
          );
        } else if (intents[index].intentArea == INTENT_AREA.POPUP) {
          if (button.id == 'create_event' && button.type == 'menu_item') {
            store.commit('common/setVisibleDialog', {
              name: 'create_event_dialog_empty',
              val: true
            });
          } else if (button.id == 'create_event') {
            store.commit('common/setVisibleDialog', {
              name: 'create_event_dialog',
              val: true
            });
            this.$emit('setSelectedEvent');
          } else if (intents[index].intentType == INTENT_TYPE.IMPORT) {
            store.dispatch('dialog/getPopupData', { item: button });
            store.commit('dialog/setSize', intents[index].size);
            store.commit('common/setVisibleDialog', {
              name: 'candidate_import_type_dialog',
              val: true
            });
          } else if (
            intents[index].intentType == INTENT_TYPE.IMPORT_SINGLE ||
            intents[index].intentType == INTENT_TYPE.IMPORT_MULTI
          ) {
            store.commit('dialog/setSize', button.size);
            store.commit('common/setVisibleDialog', {
              name:
                intents[index].intentType == INTENT_TYPE.IMPORT_SINGLE
                  ? 'candidate_import_dialog_single'
                  : 'candidate_import_dialog_multi',
              val: true
            });
          } else if (
            intents[index].intentType == INTENT_TYPE.GEAR_POPUP &&
            button.id == BUTTON.ID.NOTIFICATIONS_SETTING
          ) {
            this.$router.push({ name: MODULE.HRPAC_NOTIFICATIONS_SETTINGS });
          } else if (
            button.id == 'edit_plan' ||
            intents[index].intentType == 'plan_popup_detail'
          ) {
            if (intents[index].intentType == 'plan_popup_detail') {
              setTimeout(() => {
                store.commit('common/setVisibleDialog', {
                  name: 'plan_popup_detail',
                  val: true
                });
                store.commit('dialog/setSize', 'L');
              }, 0);
            }
            const response = await this.sendFormRequestFromIntent(
              intents[index]
            );
            store.commit('dialog/setMetadataDialog', response.data.metadata);
            store.commit('dialog/setBeanDialog', response.data.bean);
            if (button.id == 'edit_plan') {
              store.commit('common/setVisibleDialog', {
                name: 'plan_popup_detail',
                val: false
              });
            }
            store.commit('common/setVisibleDialog', {
              name: intents[index].intentType,
              val: true
            });

            store.commit('dialog/setSize', 'L');
          } else if (intents[index].request) {
            store.dispatch('dialog/getPopupData', { item: button });
          } else {
            store.commit('common/setVisibleDialog', {
              name: intents[index].intentType,
              val: true
            });
          }
        } else if (intents[index].intentArea == INTENT_AREA.CUSTOM_POPUP) {
          if (button.id == 'create_event') {
            store.commit('dialog/setSize', intents[index].size);
            store.commit('common/setVisibleDialog', {
              name: 'create_event_dialog',
              val: true
            });
          } else if (button.name?.includes('_FILTERS')) {
            store.commit('filters/setIntents', intents[index]);
            store.commit('common/setVisibleDialog', {
              name: 'filters_dialog',
              val: true
            });
          }
          if (button.name?.includes('_SORT')) {
            store.commit('filters/setIntents', intents[index]);
            store.commit('common/setVisibleDialog', {
              name: 'sort_dialog',
              val: true
            });
          }
          if (button.id == 'apply_for') {
            const response = await mixin.methods.sendFormRequestFromIntent(
              intents[index]
            );

            if (response?.data?.data) {
              eventBus.$emit(
                EVENTBUS_EVENTS.ATTACHMENT_SHOW_CONFIRM_POPUP,
                response.data
              );
              return;
            }
          }
          if (button.id == 'change_password' || button.id == 'change_status') {
            const response = await this.sendFormRequestFromIntent(
              intents[index]
            );

            response.data.metadata.buttons_menu[0][1].intents[0].type =
              button.id;

            store.commit('dialog/setMetadataDialog', response.data.metadata);
            store.commit('dialog/setSize', intents[index].size);
            store.commit('dialog/setBeanDialog', response.data.bean);
            store.commit('dialog/setVisibleSingleDialog', true);
          }
          if (intents[index].intentType == INTENT_TYPE.PROGRESS_POPUP) {
            const response = await this.sendFormRequestFromIntent(
              intents[index]
            );
            store.commit('dialog/setMetadataDialog', response.data.metadata);
            store.commit('dialog/setSize', intents[index].size);
            store.commit('dialog/setBeanDialog', response.data.bean);
            store.commit('common/setVisibleDialog', {
              name: 'mass_save_resume_progress_dialog',
              val: true
            });
          }
          if (
            button.id == 'send_test_mail' ||
            (button.id === 'delete' && this.$route.meta.module === MODULE.USERS)
          ) {
            const response = await this.sendFormRequestFromIntent(
              intents[index]
            );
            store.commit('dialog/setMetadataDialog', response.data.metadata);
            store.commit('dialog/setSize', intents[index].size);
            store.commit('dialog/setBeanDialog', response.data.bean);
            store.commit('dialog/setVisibleSingleDialog', true);
          }
        } else if (intents[index].intentArea == INTENT_AREA.OUTER_PAGE) {
          window.open(
            intents[index].request?.url,
            intents[index].request?.request_params?.targetBlank == true
              ? '_blank'
              : '_self'
          );
        } else if (intents[index].intentArea == INTENT_AREA.DYNAMIC_PAGE) {
          if (intents[index].intentType === 'login') {
            try {
              await this.sendFormRequestFromIntent(intents[index]);
            } finally {
              this.$router.push('/dashboard');
              location.reload();
            }
          }

          if (
            store.state.edit.exitAlert &&
            button.id !== 'back_to_edit' &&
            button.id !== 'save_as_draft' &&
            button.id !== 'send_to_approve'
          ) {
            const confirm = window.confirm('Закрыть без сохранения изменений?');
            if (!confirm) {
              return;
            }
          }
          store.commit('edit/setMetadata', {});
          store.commit('filters/setFilterAddUrl', { deleteUrl: true });
          if (intents[index].intentType == 'link') {
            window.open(intents[index].request.url, '_blank');
          } else if (
            intents[index].intentType == 'detail' &&
            intents[index].action == 'About'
          ) {
            this.$router.push({
              name: '*',
              params: {
                url: intents[index].request.url
              }
            });
          } else if (
            intents[index].intentType === 'detail' &&
            intents[index].action === 'getCoordinationDetailView'
          ) {
            this.$router.push(
              `/coordination_request/${intents[index].request.request_params?.record}`
            );
          } else if (intents[index].action == 'Logout') {
            // await getController({
            //   url: intents[index].request.url
            // });
            localStorage.setItem('auth', false);
            localStorage.setItem('rightPanelMode', null);

            window.open(process.env.VUE_APP_BASE_PATH + intents[index].request.url, '_self');
            // store.commit('rightPanel/setParam', {
            //   name: 'panelMode',
            //   val: null
            // });
            // this.$router.push('/login');
          } else if (intents[index].action === 'ShowPageAbout') {
            this.$router.push({ name: 'About' });
          } else if (
            intents[index].module == 'Dashboard' &&
            intents[index].intentType == 'StaticPage'
          ) {
            this.$router.push({ name: 'Dashboard' });
          } else if (
            intents[index].module == MODULE.COORDINATION &&
            intents[index].intentType == 'list'
          ) {
            store.dispatch('coordination/loadCoordinations', intents[index]);
          } else if (
            intents[index].intentType === 'detail' &&
            intents[index].action === 'getOfferPreview'
          ) {
            this.$emit('get-preview', intents[index]);
          } else if (
            intents[index].module == MODULE.COORDINATION_REQUEST &&
            intents[index].intentType == 'list'
          ) {
            store.dispatch(
              'coordinationRequest/loadCoordinations',
              intents[index]
            );
          } else if (
            intents[index].module == MODULE.CANDIDATE_RESPONDS &&
            intents[index].intentType == 'list'
          ) {
            store.dispatch('respond/loadResponds', {
              vacancyId: intents[index].request.request_params.vacancy_id,
              showNewResponds: !this.showOnlyNewRespondsAdvanced
            });
          } else if (
            intents[index].intentType == 'edit' &&
            button.id == 'hrpac_vacancy_mass_edit'
          ) {
            this.$router.push({ name: 'vacanciesMassEdit' });
          }

          if (
            (intents[index].action == 'EditView' ||
              intents[index].action === 'create' ||
              intents[index].action === 'getCoordinationRequestEditView') &&
            intents[index].module != MODULE.USERS
          ) {
            const id = intents[index].request?.request_params?.record || '';
            if (intents[index].module == 'HRPAC_CANDIDATES') {
              if (id) {
                this.$router.push({ name: 'candidatesEditId' });
              } else {
                this.$router.push({ name: 'candidatesEdit' });
              }
            } else if (intents[index].module == 'HRPAC_VACANCY') {
              if (id) {
                this.$router.push({ name: 'vacanciesEditId' });
              } else if (
                intents[index].request?.request_params?.duplicateFromRecord
              ) {
                this.$router.push({
                  name: 'vacanciesDuplicate',
                  params: {
                    request: intents[index].request || {}
                  }
                });
              } else {
                this.$router.push({
                  name: 'vacanciesEdit'
                });
              }
            } else if (
              intents[index].module === 'HRPAC_COORDINATION_REQUESTS'
            ) {
              if (intents[index].request?.request_params?.duplicateFromRecord) {
                this.$router.push(
                  `/coordination_request/${intents[index].request.request_params.duplicateFromRecord}/duplicate`
                );
              } else {
                const id = intents[index].request?.request_params?.record || '';

                this.$router.push(
                  id.length
                    ? `/coordination_request/edit/${id}`
                    : `/coordination_request/create`
                );
              }
            }
          } else if (intents[index].module == MODULE.USERS) {
            if (intents[index].intentType == 'detail') {
              const id = intents[index].request?.request_params?.record || '';
              this.$router.push(`/users/${id}`);
              store.dispatch('users/loadUser', id);
            } else if (intents[index].action == 'getMainUserEditMenuView') {
              this.$router.push({
                name: 'usersEditId',
                params: {
                  request: intents[index].request || {}
                }
              });
            } else if (intents[index].intentType == INTENT_TYPE.EDIT) {
              this.$router.push({
                path: `/users/edit/general`,
                params: {
                  request: intents[index].request || {}
                }
              });
            } else if (intents[index].intentType == INTENT_TYPE.LIST) {
              this.$router.push({
                path: `/users`
              });
            }
          } else if (
            intents[index].action == 'getCandidateView' &&
            intents[index].module == 'HRPAC_CANDIDATES'
          ) {
            const id = intents[index].request?.request_params?.record || '';
            this.$router.push(`/candidates/${id}`);
          } else if (
            intents[index].action == ACTION.READ_NOTIFICATION &&
            intents[index].module == MODULE.HRPAC_NOTIFICATIONS
          ) {
            store.dispatch('notifications/readAllNotifications');
          } else if (
            intents[index].action == 'get_VacancyView' &&
            intents[index].module == 'HRPAC_VACANCY'
          ) {
            const id = intents[index].request?.request_params?.record || '';
            this.$router.push(`/vacancies/${id}`);
          } else if (
            intents[index].intentType == INTENT_TYPE.LIST &&
            (intents[index].module == MODULE.VACANCY_MODULE ||
              intents[index].module == MODULE.CANDIDATES_MODULE ||
              intents[index].module == MODULE.HRPAC_CANDIDATES_DUPLICATES)
          ) {
            if (
              intents[index].action == ACTION.LIST_VIEW &&
              intents[index].module == MODULE.CANDIDATES_MODULE
            ) {
              this.$router.push('/candidates');
              eventBus.$emit(EVENTBUS_EVENTS.RELOAD_DATA);
            } else if (
              intents[index].action == ACTION.LIST_VIEW &&
              intents[index].module == MODULE.VACANCY_MODULE
            ) {
              this.$router.push({ name: 'HRPAC_VACANCY' });
            } else if (
              intents[index].module == MODULE.HRPAC_CANDIDATES_DUPLICATES
            ) {
              this.$router.push({ name: 'HRPAC_CANDIDATES_DUPLICATES' });
            } else {
              const url = this.createLinkFromIntent(intents[index].request);
              localStorage.setItem('AttachmentLink', url);
              store.dispatch('attachment/loadItemsToAttach', {
                url: url
              });
              intents[index].module == MODULE.VACANCY_MODULE
                ? this.$router.push(
                    `/candidates/AttachmentPage/${intents[index]?.request?.request_params?.candidate_id}`
                  )
                : this.$router.push(
                    `/vacancies/AttachmentPage/${intents[index]?.request?.request_params?.vacancy_id}`
                  );
            }
          } else if (
            (intents[index].action == 'getPrefilledEditViewFromVacancy' ||
              intents[index].action == 'getPrefilledEditViewFromRequest') &&
            intents[index].module == 'HRPAC_VACANCY_TEMPLATE'
          ) {
            this.$router.push({
              name: 'vacanciesTemplateId',
              params: {
                request: intents[index].request || {}
              }
            });
          } else if (
            intents[index].module === MODULE.HRPAC_COORDINATION_PLANS
          ) {
            if (
              intents[index].action === 'save_like_draft' ||
              intents[index].action === 'save_on_approval'
            ) {
              const resp = await this.sendFormRequestFromIntent(intents[index]);
              if (resp.data?.status === 'ok') {
                this.$router.push(
                  `/coordination_request/${resp.data.intents[0]?.request.request_params?.record}`
                );
              } else {
                this.showNotification({
                  offset: 100,
                  showClose: true,
                  message: resp.data?.error?.error_text || 'Ошибка',
                  duration: 6500,
                  type: 'error'
                });
              }
            } else if (intents[index].intentArea === INTENT_AREA.SEND_REQUEST) {
              return;
            } else if (intents[index].intentType === INTENT_TYPE.DETAIL) {
              this.$router.push(
                `/coordination_plan/${intents[index].request.request_params.record}`
              );
            }
          } else if (intents[index].module === MODULE.COORDINATION_REQUEST) {
            if (intents[index].intentType === 'list') {
              this.$router.push('/coordination_request');
            }
          } else if (
            intents[index].module == MODULE.HRPAC_NOTIFICATIONS_SETTINGS &&
            button.id == BUTTON.ID.TURN_ON_ALL
          ) {
            await store.dispatch('notifications/saveSettingAll', 1);
          } else if (
            intents[index].module == MODULE.HRPAC_NOTIFICATIONS_SETTINGS &&
            button.id == BUTTON.ID.TURN_OFF_ALL
          ) {
            await store.dispatch('notifications/saveSettingAll', 0);
          } else if (intents[index].request.url.includes(MODULE.COORDINATION)) {
            //если нажимаем на кнопку Перейтив вакансию в карточки Заявки, то
            //вакансия открывается в новом окне
            if (intents[index].request.url.includes('action=get_VacancyView')) {
              const route = this.$router.resolve(
                `/vacancies/${intents[index].request.request_params.record}`
              );
              window.open(route.href, '_blank');
            }
          }
        } else if (intents[index].intentArea == INTENT_AREA.ATTACH) {
          store.dispatch('attachment/attach', intents[index]);
        } else if (intents[index].intentArea == INTENT_AREA.RIGHT_PANEL) {
          if (
            button.type === 'customRightPanelButton' &&
            store.state.rightPanel.panelMode
          ) {
            store.commit('rightPanel/setParam', {
              name: 'panelMode',
              val: ''
            });
            localStorage.setItem('rightPanelMode', null);
            return;
          }

          let panelMode = '';
          switch (intents[index].intentType) {
            case 'list_stages_item':
            case 'RightPanelDefs':
              if (
                intents[index].request.request_params.content_type ==
                  'vac_card' &&
                this.currentVacancyCandidateID
              ) {
                intents[index].request.request_params.content_type =
                  'vac_card_selvac';
              } else if (
                intents[index].request.request_params.content_type ==
                  'vac_card_selvac' &&
                !this.currentVacancyCandidateID
              ) {
                intents[index].request.request_params.content_type = 'vac_card';
              }
              this.$nextTick(() => {
                const stagesPanel =
                  localStorage.getItem('currentVacancyUserId') &&
                  (intents[index].request.request_params.content_type !=
                    'vac_card' ||
                    intents[index].request.request_params.content_type !=
                      'cand_card');

                if (
                  !!store.state.rightPanel.panelMode &&
                  (stagesPanel ||
                    intents[index].intentType !== 'list_stages_item')
                ) {
                  store.dispatch('rightPanel/getMetadata', {
                    intentOrRequest: intents[index].request,
                    newCheck:
                      intents[index].intentType == 'list_stages_item'
                        ? true
                        : false
                  });
                }
              });

              if (
                intents[index].request.request_params.content_type ===
                  'vac_card' ||
                intents[index].request.request_params.content_type ===
                  'vac_card_selvac' ||
                intents[index].request.request_params.content_type ===
                  'vac_card_selcand'
              ) {
                panelMode = 'vacancyPanel';
              } else if (
                intents[index].request.url.includes('HRPAC_COORDINATION')
              ) {
                panelMode = 'coordinationPlan';
              } else {
                panelMode = 'canditatePanel';
              }
              store.commit('rightPanel/setParam', {
                name: 'updateIntent',
                val: intents[index].request
              });
              store.commit('rightPanel/setParam', {
                name: 'panelMode',
                val: panelMode
              });
              localStorage.setItem(
                'rightPanelMode',
                store.state.rightPanel.panelMode || null
              );
              if (window.innerWidth <= 1591) {
                localStorage.setItem('navMenu', false);
                eventBus.$emit('closeMenu');
              }
              break;
            default:
              break;
          }
        } else if (intents[index].intentArea == INTENT_AREA.SAVE) {
          // if (
          //   intents[index]?.request?.request_params?.module ==
          //     MODULE.HRPAC_OFFERS &&
          //   intents[index]?.request?.request_params?.loadedAction ==
          //     'get_EditView'
          // ) {
          //   this.$emit(
          //     intents[index]?.request?.request_params?.mode == 'preview'
          //       ? 'get-preview'
          //       : 'save-file',
          //     intents[index]
          //   );
          // } else {
            this.$emit('get-intent', intents);
            eventBus.$emit(EVENTBUS_EVENTS.SAVEFORM, intents);
            if (this.breakOnSave) return;
          // }
        } else if (intents[index].intentArea == INTENT_AREA.CLOSE_POPUP) {
          this.$emit('ClosePopup', intents);
          eventBus.$emit(EVENTBUS_EVENTS.CLOSE_POPUP, button.id == 'cancel');
        } else if (intents[index].intentArea == INTENT_AREA.SUBPANEL_UPLOAD) {
          //если до этого были выбраны другие этапы для скрытия - сохраняем и их
          store.commit('rightPanel/setParam', {
            name: 'hiddenStages',
            val: this.getHiddenStagesFromIntent(intents[index])
          });

          await store.dispatch(
            'subpanels/updateDataForVacancyCandidates',
            intents[index]
          );
        } else if (intents[index].intentArea == INTENT_AREA.SEND_REQUEST) {
          if (intents[index].request.url.includes('testOutboundEmail')) {
            this.$emit('get-intent', intents);
          } else {
            store.commit('event/setIntents', intents);
            this.parse();
            break;
          }
        } else if (intents[index].intentArea === INTENT_AREA.OLD_PAGE) {
          this.goToOldPage(intents[index]);
        } else if (intents[index].intentArea === INTENT_AREA.CHECK_REQUEST) {
          eventBus.$emit(EVENTBUS_EVENTS.SAVE_REQUEST_FORM, intents);
        } else {
          if (
            intents[index].request &&
            intents[index].request.url &&
            intents[index].request.request_params
          ) {
            try {
              store.commit('dialog/setLoading', true);
              const response = await getController({
                url: intents[index].request.url,
                params: intents[index].request.request_params
              });
              if (
                intents[index].intentArea == INTENT_AREA.SUBPANEL_BUTTON &&
                response &&
                response.data &&
                Array.isArray(response.data) &&
                response.data.length
              ) {
                let newButtonData = {};
                newButtonData['intents'] = [];
                newButtonData.intents.push({
                  request: {
                    request_params: {},
                    url: response.data[0].open
                  }
                });

                store.dispatch('dialog/getPopupData', { item: newButtonData });
              } else if (
                response.data?.status &&
                response.data?.status == 'error' &&
                response.data?.error?.error_text
              ) {
                this.catchError('', response.data.error.error_text);
              } else if (
                response.data?.type == 'success' &&
                response.data?.message?.length
              ) {
                this.showNotification({
                  offset: 100,
                  showClose: true,
                  message: response.data?.message,
                  duration: 6500,
                  type: 'success'
                });
              }
            } catch (err) {
              this.catchError(err, 'Возникла ошибка');
            } finally {
              store.commit('dialog/setLoading', false);
            }
          }
        }
      }
    }
  },
  beforeDestroy() {
    if (this.topPanel) {
      eventBus.$off(EVENTBUS_EVENTS.SAVEFORM);
    }
  },
  components: {
    Tooltip,
    Button,
    ActionsMenu,
    Switcher
  }
};
</script>
>
<style lang="scss" scoped>
.actions-menu {
  display: flex;
  border-radius: 4px;
  align-items: center;
}

.buttons-panel {
  width: fit-content;

  &__buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;

    .el-button:not(:last-of-type) {
      margin-right: 0;
    }
  }

  &__switcher {
    display: flex;
    gap: 16px;
  }
}

.gap16 {
  gap: 16px;
}

@media (max-width: 1239px) {
  .right-panel-button {
    display: none;
  }
}
</style>
